import {BrowserRouter, Route, Routes as Router,} from "react-router-dom";
import React, {useEffect} from 'react';
import {AuthProvider, RequireAuth} from "../Components/Providers/Authorization/Authorization.provider";
import {AlertProvider} from "../Components/Providers/Alert/Alert.provider";
import {ConfirmationProvider} from "../Components/Providers/ConfirmDialog/ConfirmDialog.provider";
import NoMatch from "./NoMatch/NoMatch";
import HomePage from "./Public/Home/HomePage";
import ContactsPage from "./Public/Contacts/ContactsPage";
import {Demographic} from "./Public/TestForm/Demographic";
import {Personality} from "./Public/TestForm/Personality";
import {ItemsCollectionLiked} from "./Public/TestForm/ItemsCollectionLiked";
import {Feedback} from "./Public/TestForm/Feedback";
import {Completed} from "./Public/TestForm/Completed";
import {TestStatusProvider} from "../Components/Providers/TestStatus/TestStatus.provider";
import {TermsPage} from "./Public/Terms/TermsPage/TermsPage";
import ReactGA from "react-ga4";
import {ItemsCollectionDisliked} from "./Public/TestForm/ItemsCollectionDisliked";


const TRACKING_ID = "G-204H7SZNKK"; // your Measurement ID

const Routes = () => {
  useEffect(() => {
    ReactGA.initialize(TRACKING_ID);
  }, [])
  return (

      <AlertProvider>
        <AuthProvider>
        <ConfirmationProvider>
          <TestStatusProvider>
            <BrowserRouter>
              <Router>
                <Route path="/" element={<HomePage/>}/>
{/*
                <Route path={"/test"}>
                  <Route index path={"demographic"} element={<RequireAuth><Demographic/></RequireAuth>}/>
                  <Route path={"personality"} element={<RequireAuth><Personality/></RequireAuth>}/>
                  <Route path={"liked-items"} element= {<RequireAuth><ItemsCollectionLiked/></RequireAuth>}/>
                  <Route path={"disliked-items"} element= {<RequireAuth><ItemsCollectionDisliked/></RequireAuth>}/>
                  <Route path={"feedback"} element={<RequireAuth><Feedback/></RequireAuth>}/>
                  <Route path={"completed"} element={<RequireAuth><Completed/></RequireAuth>}/>
                  <Route path={"*"} element={<NoMatch/>}/>
                </Route>
*/}
                <Route path={"/contacts"} element={<ContactsPage/>}/>
                <Route path={"/terms"} element={<TermsPage/>}/>
                <Route path="*" element={<NoMatch/>}/>
              </Router>
            </BrowserRouter>
          </TestStatusProvider>
        </ConfirmationProvider>
        </AuthProvider>
    </AlertProvider>
  );
}

export default Routes;
